import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Title = styled.div.withConfig({
  displayName: "partials__Title",
  componentId: "sc-1g8948c-0"
})(["display:flex;align-items:center;margin-bottom:16px;", " span{display:block;flex-grow:1;flex-shrink:1;height:2px;background-color:", ";}h3{", " margin:0 12px 0 0;font-weight:500;font-variant:small-caps;color:", ";text-transform:lowercase;}span + h3{margin-left:12px;}"], function (_ref) {
  var _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? false : _ref$marginTop;
  return marginTop && "margin-top: 20px;";
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.ui;
}, getFont(0), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.fontL;
});